export function getVoucherExpiryDate(purchaseDate, expiresAt) {
  if (expiresAt) {
    return expiresAt;
  }

  if (!purchaseDate) {
    return null;
  }

  const date = new Date(purchaseDate);
  date.setFullYear(date.getFullYear() + 2);
  return date.toISOString();
}

export function getLocalDateInputValue(date = new Date()) {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function pickBestDateTime(primaryValue, fallbackValue) {
  const primaryHasTime = typeof primaryValue === 'string' && /[T\s]\d{2}:\d{2}/.test(primaryValue.trim());
  const fallbackHasTime = typeof fallbackValue === 'string' && /[T\s]\d{2}:\d{2}/.test(fallbackValue.trim());

  if (primaryHasTime) {
    return primaryValue;
  }

  if (fallbackHasTime) {
    return fallbackValue;
  }

  return primaryValue || fallbackValue || null;
}

export function formatDateTime(value) {
  if (!value) {
    return 'No disponible';
  }

  const rawValue = typeof value === 'string' ? value.trim() : '';
  const hasExplicitTime = rawValue ? /[T\s]\d{2}:\d{2}/.test(rawValue) : true;

  if (!hasExplicitTime) {
    return formatDate(value);
  }

  return new Intl.DateTimeFormat('es-ES', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatDate(value) {
  if (!value) {
    return 'No disponible';
  }

  return new Intl.DateTimeFormat('es-ES', {
    dateStyle: 'medium',
  }).format(new Date(value));
}
